import { Skeleton } from '../ui/skeleton';
import { SignInFrame } from './sign-in-frame';

/** Shown while the session probe runs, in the same frame so the page does not jump. */
export function SignInSkeleton() {
  return (
    <div className="h-full" role="status" aria-label="Checking your session">
      <SignInFrame>
        <div className="flex flex-col gap-8">
          <div className="flex flex-col gap-3">
            <Skeleton className="h-8 w-3/4" />
            <Skeleton className="h-4 w-full" />
          </div>
          <Skeleton className="h-9 w-full" />
        </div>
      </SignInFrame>
    </div>
  );
}
